import React from "react"
import Helmet from "react-helmet"
import { Link, graphql } from "gatsby"
import { motion, AnimateSharedLayout, AnimatePresence } from "framer-motion"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/Home/Hero"
import About from "../components/About/About"
import FeaturedProject from "../components/Project/FeaturedProject"
import FeaturedPosts from "../components/Blog/FeaturedPosts"
import ContactComponent from "../components/Contact/ContactComponent"
import Testimonial from "../components/Testimonial/Testimonial"
import Skills from "../components/Home/Skills"

const IndexPage = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Danniel Hansel`
  const siteAuthor = data.site.siteMetadata?.author.name || `Danniel Hansel`
  const siteUrl = data.site.siteMetadata.canonicalUrl
  const siteDescription = data.site.siteMetadata?.description
  // const siteDescription = `Hi, I'm Danniel Hansel. I'm a Software Engineer based in Dallas, Texas. I post things on here about technology, problems that I solved and my life experiences as a student.`
  // const shortAbout = data.about.edges.node.slug
  console.log(process.env.ROOT_URL)
  return (
    <AnimateSharedLayout type="crossfade">
      <AnimatePresence>
        <Layout location={location} title={siteTitle} >
          <SEO 
            title="Danniel Hansel" 
            author={siteAuthor} 
            description={siteDescription} 
            keywords={[
              'Software Engineer',
              'React Enthusiast',
              'Freelancer',
              "Javascript Enthusiast",
              "Full Stack Developer",
              "Front End Developer", 
              "danniel", 
              "danniel hansel", 
              "daniel", 
              "danielhansel"]}
            url={`${siteUrl}`} />
          <Hero content={data.hero.edges} />
          {/* <About content={data.about.edges} placeholderImage={data.placeholderImage.childImageSharp}/> */}
          <About content={data.about.edges} />
          <FeaturedProject content={data.project.edges} />
          {/* <Skills /> */}
          <FeaturedPosts content={data.featured.edges} />
          <Testimonial content={data.testimonial.edges} />
        </Layout>
      </AnimatePresence>
    </AnimateSharedLayout>
  )
}

export const pageQuery = graphql`
  {
    site {
      siteMetadata {
        title
        description
        canonicalUrl
        image
        author {
          name
        }
        organization {
          name
          url
          logo
        }
        social {
          twitter
        }
      }
    }
    hero: allMdx(filter: { fileAbsolutePath: { regex: "/content/hero/" } }) {
      edges {
        node {
          body
          frontmatter {
            intro
            title
          }
        }
      }
    }
    about: allMdx(
    filter: {fileAbsolutePath: {regex: "/content/about/"}, slug: {eq: "about/about"}}
    ) {
      edges {
        node {
          slug
          body
          frontmatter {
            title
            caption
            description
            author
            profileUrl
            category
          }
        }
      }
    }
    testimonial: allMdx(
      filter: { fileAbsolutePath: { regex: "/content/testimonial/" } }
    ) {
      edges {
        node {
          body
          frontmatter {
            title
            author
            company
            thumbnailUrl
          }
        }
      }
    }
    project: allMdx(
      limit: 3
      filter: {
        fileAbsolutePath: { regex: "/content/project/" }
        frontmatter: { visible: { eq: "true" } }
      }
      sort: { fields: frontmatter___position, order: ASC }
    ) {
      edges {
        node {
          body
          frontmatter {
            title
            visible
            tags
            position
            live
            github
            external
            category
            thumbnailUrl
          }
        }
      }
    }
    featured: allMdx(
      limit: 6
      filter: {
        fileAbsolutePath: { regex: "/content/blog/" }
        frontmatter: { published: { eq: true }, featured: { eq: true } }
      }
      sort: { order: DESC, fields: frontmatter___date }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
          }
          excerpt
          id
          body
          timeToRead
        }
      }
    }
  }
`
export default IndexPage
